import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import VectorImage from 'src/assets/logos/Vector.svg';
import METRIC_CONFIGS from 'src/constants/metrics.constants';

import NormalInput from 'src/components/normalInputs';

function BrandInputs({ inputs, onChange, availableMetrics, t, classes }) {
  const seenKeys = new Set();
  const uniqueInputs = [];

  availableMetrics?.forEach(metric => {
    const config = METRIC_CONFIGS[metric];
    if (!config) return;

    config.inputs.forEach(field => {
      if (!seenKeys.has(field.key)) {
        seenKeys.add(field.key);
        uniqueInputs.push(field);
      }
    });
  });

  return (
    <Box className={classes.brandContent}>
      <Box className={classes.brandHeader}>
        <img src={VectorImage} alt="Vector" />
        <Typography variant="Heading-4">
          {t('businessCase.brandInputs')}
        </Typography>
      </Box>

      <Box className={classes.brandInputs}>
        {uniqueInputs.map(field => (
          <NormalInput
            key={field.key}
            label={field.label}
            value={inputs[field.key]}
            suffix={field.suffix || ''}
            max={field.max}
            requirePositive
            onChange={v => onChange({ ...inputs, [field.key]: v })}
          />
        ))}

        <NormalInput
          label="RRP"
          value={inputs.rrp || 0}
          suffix="€"
          onChange={v => onChange({ ...inputs, rrp: v })}
        />
      </Box>
    </Box>
  );
}

BrandInputs.propTypes = {
  inputs: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.number, PropTypes.string])
  ).isRequired,
  onChange: PropTypes.func.isRequired,
  availableMetrics: PropTypes.arrayOf(PropTypes.string).isRequired,
  t: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired
};

export default BrandInputs;
